import { request as __request } from '../core/request';
export class PublicPlanService {
    /**
     * @returns any Success
     * @throws ApiError
     */
    static getList() {
        return __request({
            method: 'GET',
            path: `/api/plans`,
        });
    }
}
